import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DepartmentKey } from '../../../common/models/department-key-model';
import { EmployeeKey } from '../../../common/models/employee-key.model';
import { QueryResult } from '../../../common/rest-api/models/query-result';
import { RequestParams } from '../../../common/rest-api/models/request-params';
import { RestApiService } from '../../../common/rest-api/services/rest-api.service';
import { GarmentReportSummary } from '../models/garment-report-summary.model';


@Injectable({
  providedIn: 'root',
})
export class GarmentSummaryService extends RestApiService<GarmentReportSummary> {

  protected resourcePath = '/garment-summary';
  protected modelType = GarmentReportSummary;


  async getForEmployee(employeeKey: EmployeeKey): Promise<GarmentReportSummary> {
    const params = new RequestParams();
    params.queryParams.params.CustomerCode = employeeKey.CustomerCode;
    params.queryParams.params.DepartmentCode = employeeKey.DepartmentCode;
    params.queryParams.params.EmployeeCode = employeeKey.EmployeeCode;

    const url = this.buildEndpointUrl('', params);
    const response = GarmentReportSummary.from(await this.cloudApiMiddleware.cloudRequest<GarmentReportSummary>({
      url
    }, 'GET'));

    return response;
  }
}